// OMI Wheels — nav fix
// Forces navigation on dropdown leaf links in case theme JS intercepts clicks
(function () {
  function fix() {
    document.querySelectorAll('.nav-dropdown a').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href');
        if (href && href !== '#' && href.indexOf('#') === -1) {
          e.stopImmediatePropagation();
          window.location.href = href;
        }
      });
    });
  }
  if (document.readyState !== 'loading') { fix(); }
  else { document.addEventListener('DOMContentLoaded', fix); }
})();
